<company *ngIf="company" [company]="company"></company>
<company-structure [companyId]="companyId" [editable]="isEditable"></company-structure>
